class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.isMegaMenu = this.mainDetailsToggle?.classList.contains('mega-menu');
    this.closeTimeout = null;
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.onSummaryClick = this.onSummaryClick.bind(this);
    this.addEventListener('mouseenter', this.onMouseEnter);
    this.addEventListener('mouseleave', this.onMouseLeave);
    this.querySelector('summary')?.addEventListener('click', this.onSummaryClick);
  }

  disconnectedCallback() {
    this.removeEventListener('mouseenter', this.onMouseEnter);
    this.removeEventListener('mouseleave', this.onMouseLeave);
    this.querySelector('summary')?.removeEventListener('click', this.onSummaryClick);
  }

  isDesktop() {
    return window.matchMedia('(min-width: 1100px)').matches;
  }

  onSummaryClick(event) {
    if (!this.isDesktop() || event.pointerType !== 'mouse') return;
    event.preventDefault();
    const href = event.currentTarget.dataset.href;
    if (href) {
      window.location.href = href;
      return;
    }
    this.openMenu();
  }

  onMouseEnter() {
    if (!this.isDesktop()) return;
    clearTimeout(this.closeTimeout);
    this.openMenu();
  }

  onMouseLeave() {
    if (!this.isDesktop()) return;
    this.closeTimeout = setTimeout(() => this.close(), 180);
  }

  openMenu() {
    this.cancelClosing();
    document.querySelectorAll('header-menu > details[open]').forEach((details) => {
      if (details !== this.mainDetailsToggle) {
        details.removeAttribute('open');
        details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      }
    });

    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary')?.setAttribute('aria-expanded', 'true');
    this.header?.classList.toggle('mega-menu-open', this.isMegaMenu);
    this.header && (this.header.preventHide = true);
  }

  // Desktop: keep [open] while the close animation plays, then close for real
  close() {
    const details = this.mainDetailsToggle;
    const animate =
      this.isDesktop() &&
      details?.hasAttribute('open') &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!animate) {
      this.cancelClosing();
      this.closeNow();
      return;
    }

    if (details.classList.contains('is-closing')) return;
    details.classList.add('is-closing');
    this.closingTimeout = setTimeout(() => {
      details.classList.remove('is-closing');
      this.closeNow();
    }, 260);
  }

  cancelClosing() {
    clearTimeout(this.closingTimeout);
    this.mainDetailsToggle?.classList.remove('is-closing');
  }

  closeNow() {
    super.close();
    if (!document.querySelector('header-menu details.mega-menu[open]')) {
      this.header?.classList.remove('mega-menu-open');
      if (this.header) this.header.preventHide = false;
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (this.isMegaMenu) {
      this.header.classList.toggle('mega-menu-open', this.mainDetailsToggle.open);
    }

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:block:select', (event) => {
    const megaTarget = event.target.closest?.('.mega-menu__highlights, .mega-menu__highlight, .mega-menu__panel');
    const details = megaTarget?.closest('details.mega-menu');
    if (!details) return;
    details.setAttribute('open', '');
    document.querySelector('.header-wrapper')?.classList.add('mega-menu-open');
  });
}
